import axiosInstance from './axiosInstance';

export const getAllCustomers = () =>
    axiosInstance.get("/Customer/GetAllCustomers");

export const getCustomerWithSales = (customerId) =>
    axiosInstance.get(`/Customer/GetCustomerWithSales?customerId=${customerId}`);

export const createCustomer = (request) =>
    axiosInstance.post("/Customer/CreateCustomer", request);

export const updateCustomer = (request) =>
    axiosInstance.put("/Customer/UpdateCustomer", request);

export const bulkUpdateCustomersBySalesId = (rows) =>
    axiosInstance.post("/Customer/BulkUpdateBySalesId", rows);
